// extracted by mini-css-extract-plugin
module.exports = {"SSearch":"Search_SSearch__p0f8H","SSearchInput":"Search_SSearchInput__NM_dJ","SSearchButton":"Search_SSearchButton__qy_tc","SSearchSvg":"Search_SSearchSvg__gcmsy"};